<template>
<div class="chapter">
<div class="inner_page">
<p class="ct1" id="d7e151019"><a href="#/Text/Auth_ISBN9781402790959_epub_toc_r1#d7e2986" id="d14e500"><b>PART I</b></a></p>
<p class="h5" id="d7e151519"><a href="#/Text/Auth_ISBN9781402790959_epub_toc_r1#d7e2986" id="d14e504">T<span class="small">HE </span>K<span class="small">NIFE, THE </span>F<span class="small">IRE, AND THE </span>W<span class="small">OOD </span></a></p>
<p class="txc" id="d7e152319"><i>And [Isaac] said, “Here are the fire and the wood,<br/>but where is the lamb for the offering?” …<br/>Abraham stretched out his hand,<br/>and took the knife.</i></p>
<p class="txr13" id="d7e154119">G<span class="small">ENESIS 22:7–9 </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Auth_ISBN9781402790959_epub_c11_r1.vue?00630af0